export default "__VITE_ASSET__58c58d09__"